import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import httpRequest from "../../../utils/Http";

const PartnerUpcountry = ({ partnerDetails, setPartnerDetails, role_id }) => {
  const [formData, setFormData] = useState({
    is_upcountry: 0,
    upcountry_rate: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    if (partnerDetails) {
      setFormData({
        ...formData,
        partner_id: partnerDetails.partner_id,
        is_upcountry: partnerDetails.is_upcountry,
        upcountry_rate: partnerDetails.upcountry_rate,
      });
    }
  }, [partnerDetails]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    if (value.is_upcountry) {
      if (!value.upcountry_rate) {
        errors.upcountry_rate = "Upcountry Rate is mandatory";
      }
      if (value.upcountry_rate && value.upcountry_rate < 1) {
        errors.upcountry_rate = "Upcountry Rate should be greater than one";
      }
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "updatepartnerupcountry",
          formData,
          "POST",
        );
        if (data.status === true && data.message) {
          toast.success(data.message);

          setPartnerDetails(data.data);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
  }, [isSubmit, formErrors]);

  return (
    <div className="partner-upcountry-shell">
      <div className="card partner-upcountry-card">
        <div className="card-header partner-upcountry-header">
          <h3 className="card-title mb-0">Upcountry Settings</h3>
        </div>

        <form
          className="card-body partner-upcountry-form"
          id="upcountryform"
          onSubmit={onSubmitHandler}
        >
          <div className="form-group">
            <label className="form-label d-block mb-2">Service status</label>
            <div className="custom-control custom-switch dashboard-custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="is_upcountry"
                name="is_upcountry"
                checked={Boolean(formData.is_upcountry)}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    is_upcountry: e.target.checked,
                  });
                }}
              />
              <label
                className="custom-control-label"
                htmlFor="is_upcountry"
                style={{ paddingRight: "10px" }}
              >
                Enable upcountry billing for this partner
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="upcountry_rate" className="form-label">
                  Rate Per KM <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className={`form-control ${formErrors.upcountry_rate ? "is-invalid" : ""}`}
                  step="0.01"
                  min={1}
                  id="upcountry_rate"
                  placeholder="Enter rate per KM"
                  value={formData.is_upcountry ? formData.upcountry_rate : 0}
                  name="upcountry_rate"
                  disabled={!formData.is_upcountry}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      upcountry_rate: e.target.value,
                    });
                  }}
                />
                {formErrors.upcountry_rate && (
                  <div className="invalid-feedback d-block">
                    {formErrors.upcountry_rate}
                  </div>
                )}
              </div>
            </div>
          </div>

          {Number(role_id) === 1 && (
            <div className="d-flex justify-content-end mt-3">
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-save mr-2"></i>
                Save Settings
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default PartnerUpcountry;
